import { html } from "lit";

import type { MenuItem } from "./types";

import { type TranslationKey, t } from "../../translations/i18n";

type MenuTranslationKey = Extract<TranslationKey, `menu.${string}`>;

export const DESKTOP_MENU_ITEMS: MenuItem<MenuTranslationKey>[] = [
  {
    path: "profile",
    label: t("menu.editProfile"),
    icon: html`<ph-user weight="bold" size="20"></ph-user>`,
  },
  {
    path: "links",
    label: t("menu.links"),
    icon: html`<ph-link weight="bold" size="20"></ph-link>`,
  },
  {
    path: "worlds",
    label: t("menu.worlds"),
    icon: html`<ph-images weight="bold" size="20"></ph-images>`,
  },
  {
    path: "analytics",
    label: t("menu.analytics"),
    icon: html`<ph-chart-bar weight="bold" size="20"></ph-chart-bar>`,
  },
  {
    path: "settings",
    label: t("menu.accountSettings"),
    icon: html`<ph-gear weight="bold" size="20"></ph-gear>`,
  },
];

export const MOBILE_MENU_ITEMS: Array<MenuItem<MenuTranslationKey>> = [
  { path: "profile", label: t("menu.profile"), icon: html`<ph-user weight="bold" size="20"></ph-user>` },
  { path: "links", label: t("menu.links"), icon: html`<ph-link weight="bold" size="20"></ph-link>` },
  { path: "worlds", label: t("menu.worlds"), icon: html`<ph-images weight="bold" size="20"></ph-images>` },
];

export const FAN_MENU_ITEMS: Array<MenuItem<MenuTranslationKey>> = [
  {
    path: "onboard-creator?step=1",
    label: t("menu.becomeCreator"),
    icon: html`<ph-crown weight="bold" size="20"></ph-crown>`,
  },
  {
    path: "settings",
    label: "Support",
    icon: html`<ph-question weight="bold" size="20"></ph-question>`,
  },
];
